import React, { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import './Dashboard.css';
import VerticalNavbar from './VerticalNavbar';
import BottomNavbar from './BottomNavbar';
import { ThemeContext } from '../../context/ThemeContext';

const DashBoard = ({ onCreateClick }) => {
  const [isNavOpen, setIsNavOpen] = useState(true);
  const [theme, setTheme] = useState(() => localStorage.getItem('dmyor-theme') || 'light');

  const toggleTheme = useCallback(() => {
    setTheme(t => {
      const next = t === 'dark' ? 'light' : 'dark';
      localStorage.setItem('dmyor-theme', next);
      return next;
    });
  }, []);

  useEffect(() => {
    document.body.classList.toggle('app-dark', theme === 'dark');
    document.body.classList.toggle('app-light', theme === 'light');
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className={`dashboard ${isNavOpen ? 'nav-open' : 'nav-closed'}`}>

        {/* Toggle Button (Desktop only) */}
        <button
          className="nav-toggle-btn d-none d-md-block"
          onClick={() => setIsNavOpen(prev => !prev)}
        >
          <i className={`bx ${isNavOpen ? 'bx-menu-alt-right' : 'bx-menu'}`} />
        </button>

        {/* Sidebar */}
        <aside className={`v-nav ${isNavOpen ? 'show' : 'hide'}`}>
          <VerticalNavbar onCreateClick={onCreateClick} />
        </aside>

        {/* Main Content */}
        <main className="user-portal">
          <Outlet />
        </main>

        {/* Mobile Bottom Nav */}
        <div className="bottom-navbar d-md-none">
          <BottomNavbar onCreateClick={onCreateClick} />
        </div>

      </div>
    </ThemeContext.Provider>
  );
};

export default DashBoard;
